export const BRIDGE_CHANNEL = 'ping.game.bridge';
export const REACT_SOURCE = 'ping-react';
export const GAME_SOURCES = new Set(['ping-game', 'game', 'unity']);

const TEXT_FIELD_NAMES = new Set(['value', 'text', 'input', 'data', 'message', 'prompt']);

const EVENT_VERBS = {
  score_update: 'scored',
  question_answered: 'answered',
  button_clicked: 'interacted',
  route_step: 'progressed',
  level_start: 'initialized',
  level_complete: 'completed',
  module_complete: 'completed',
  game_complete: 'completed',
  game_error: 'failed'
};

export const isGameBridgeMessage = (data) => {
  if (!data || typeof data !== 'object') return false;
  if (data.channel === BRIDGE_CHANNEL && GAME_SOURCES.has(data.source)) return true;
  return data.source === 'unity';
};

export const normalizeBridgeMessage = (data) => {
  if (!isGameBridgeMessage(data)) return null;

  const legacyType = data.type;
  const type = data.type === 'unity_ready' ? 'game_ready' : data.type;

  return {
    channel: data.channel || BRIDGE_CHANNEL,
    source: data.source,
    type,
    legacyType,
    messageId: data.messageId,
    payload: data.payload || {}
  };
};

const getDisplayName = (user) => {
  if (!user) return 'Guest';
  return user.full_name || user.username || 'Student';
};

export const buildAuthContext = ({
  user,
  sessionData,
  moduleId,
  consentGranted,
  storyContext = null
}) => ({
  schema: 'ping.auth_context.v1',
  sessionId: sessionData?.session_id || null,
  moduleId,
  user: {
    isAuthenticated: !!user && user.role !== 'guest',
    role: user?.role || 'guest',
    displayName: getDisplayName(user),
    organizationId: user?.organization_id || null
  },
  guestId: sessionData?.guest_id || null,
  telemetry: {
    enabled: sessionData?.org_settings?.telemetry_enabled !== false && !!consentGranted,
    consentGranted: !!consentGranted
  },
  story: storyContext || null
});

const sanitizePayload = (payload = {}) => {
  const safe = {};
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (TEXT_FIELD_NAMES.has(String(key).toLowerCase())) return;
    safe[key] = value;
  });
  return safe;
};

export const normalizeGameEvent = (payload = {}, { moduleId }) => {
  const safe = sanitizePayload(payload);
  const eventName = safe.event_name || safe.eventType || safe.type || 'game_event';
  const score = typeof safe.score === 'number' ? { raw: safe.score } : safe.score;

  return {
    ...safe,
    event_name: eventName,
    verb: safe.verb || EVENT_VERBS[eventName] || 'experienced',
    object_id: safe.object_id || `modules/${moduleId}/events/${eventName}`,
    score
  };
};

